import { useEffect, useRef } from "react";
import { api } from "../lib/api";
import { Sparkles } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const hash = window.location.hash || "";
      const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      let ok = false;
      if (sessionId) {
        try {
          const { data } = await api.post("/auth/google/session", { session_id: sessionId });
          localStorage.setItem("glam_token", data.token);
          ok = true;
        } catch {
          ok = false;
        }
      }
      window.history.replaceState(null, "", window.location.pathname);
      window.location.replace(ok ? "/studio" : "/auth?mode=login");
    };
    run();
  }, []);

  return (
    <div className="min-h-screen bg-[#0F0E13] flex flex-col items-center justify-center gap-4" data-testid="google-callback-screen">
      <Sparkles className="w-6 h-6 text-[#E3C2B0] animate-pulse" strokeWidth={1.5} />
      <p className="text-xs uppercase tracking-[0.4em] text-[#A8A6A1]">Signing you in…</p>
    </div>
  );
}
